import { TransportOrderState } from "./transportOrder";

export interface TransportOrderNotificationListQueryParameters {
    employeeId: string;
    source?: number;
}

export interface TransportOrderNotificationListItemDto {
    id: string;
    transportOrderId: string;
    employeeId: string;
    vehicleId: string;
    message: string;
    createdDateTime: string;
    modifiedDateTime: string;
    transportOrderName: string;
    transportOrderNumber: string;
    vehicleRegisterNumber: string;
    orderState: TransportOrderState;
    state: TransportOrderNotificationState;
    source: NotificationSource;
    createdEmployee: string;
    modifiedEmployeeId: string;
}

export interface TransportOrderNotificationDto {
    id: string;
    transportOrderId: string;
    employeeId: string;
    vehicleId: string;
    message: string;
    createdDateTime: string;
}

export enum TransportOrderNotificationState {
    Created = 0,
    Notified = 1,
    Confirmed = 2
}

export enum NotificationSource {
    Desktop = 1,
    Mobile = 2,
}
